import QuillDelta from 'quill-delta';

import { QuillEditor } from './quill/QuillEditor';

export function QuillText(props) {
	return <QuillEditor readOnly {...props} />;
}

QuillText.isEmpty = function QuillTextIsEmpty(value?: QuillDelta) {
	if (!value) {
		return true;
	}

	return (
		value.ops
			.map((op) => op.insert ?? '')
			.join('')
			.trim().length === 0
	);
};
